import React from 'react';
import { func } from 'prop-types';
import { styled } from '@nextiva/next-ui-components';
import { CREATE_ROLE } from 'constants/drawerTitles';
import { CREATE_ROLE_OBJ } from 'constants/roles';

export const Card = styled('div')`
  position: relative;
  padding: 1rem;
  border-radius: 5px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.16);
`;

const CreateRoleCard = ({ onClickRoleCardHandler }) => {
  return (
    <div
      onClick={() => onClickRoleCardHandler(CREATE_ROLE_OBJ, CREATE_ROLE)}
      data-testid="PlatformAdminUI-CreateRoleCard-CreateRole"
      role="presentation"
    >
      <Card className="m-create-role-card">+ Create Role</Card>
    </div>
  );
};

CreateRoleCard.propTypes = {
  onClickRoleCardHandler: func.isRequired,
};

export default CreateRoleCard;
